import PowerCostInput from 'components/Layout/Mining/MiningCalculator/PowerCostInput';

interface Props {
  value: string;
  name: string;
}

const Summary = (props: Props) => {
  const { value, name } = props;

  return (
    <div className="mining-calculator__summary">
      <div className="mining-calculator__summary-power-cost">
        <h2 className="mining-calculator__summary-power-cost-header">{name}</h2>
        <PowerCostInput value={value} />
      </div>
    </div>
  );
};

export default Summary;
